import { React, useState } from 'react'
import AddNewProblem from './AddNewProblem'
import { isBefore, parse, format } from 'date-fns';

const Problems = ({ expandAll, data, setIsRecordSaved, ...props }) => {
  console.log("Problems", data)
  let { isViewAllowed, IsEditAllowed, IsDeleteAllowed } = props;
  const [isOpenProblems, setIsOpenProblems] = useState(false);
  const [problemsID, setProblemsID] = useState();
  const [showInActiveProblems, setShowInActiveProblems] = useState(false);
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }

  const AddProblems = (ID) => {
    if (!isViewAllowed) return;
    setProblemsID(ID)
    setIsOpenProblems(prev => !prev);
  }
  const CloseProblems = () => {
    setIsOpenProblems(false)
  }

  let PopupScreen = "";
  if (isOpenProblems) {
    PopupScreen = <AddNewProblem isOpenProblems={isOpenProblems} problemsID={problemsID} setProblemsID={setProblemsID} onClose={CloseProblems} // onDeleteProblems={DeleteProblems} 
      setIsRecordSaved={setIsRecordSaved}
      setIsRecordSavedType={props?.setIsRecordSavedType} patientID={props?.patientID} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
    />
  }
  // const handleInActiveProblems = (endDate) => {
  //   if(endDate){
  //     const parsedEndDate = parse(endDate, 'MM/dd/yyyy', new Date());
  //     const parsedCurrDate = parse(format(new Date(), 'MM/dd/yyyy'), 'MM/dd/yyyy', new Date());
  //     // console.log("handleInActiveProblems",parsedEndDate,parsedCurrDate,isBefore(parsedEndDate, parsedCurrDate))
  //     if (isBefore(parsedEndDate, parsedCurrDate)) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return true;
  //   }
  // }
  const ShowHideInActive = () => {
    // let inActive = !(item.isActive="true");
    // let inActiveCount = data.filter(item => (handleInActiveProblems(item.EndDate))).length;
    let inActiveCount = data.filter(item => ((item.isActive === "false"))).length;
    // console.log("inActiveCountProblems",inActiveCount)
    return inActiveCount > 0 ? <p className='heading validate-color cursor-pointer px-2 pt-2' onClick={() => setShowInActiveProblems(prev => !prev)}>
      {showInActiveProblems ? `Hide InActive(${inActiveCount})` : `Show InActive(${inActiveCount})`}
    </p> : null
  }

  return (
    <>
      {PopupScreen}
      <div className='content-box px-0'>
        <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-1 mb-1 mx-2'>
          <p className='cursor-pointer fs-13 heading user-select-none' onClick={handleToggleExpand}>Problems</p>

          <i className={`icon-dash-plus fs-19 ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddProblems(null)}></i>
        </div>
        <div >
          {expandItems &&
            expandAll &&
            (data?.length > 0 ?
              <>
                <div className="d-flex flex-column gap-2 hover-scrollbar problem-scroll px-2">
                  {data.map(item => {
                    // let inActive = handleInActiveProblems(item.EndDate);
                    let inActive = !(item.isActive === "true");
                    if ((inActive && !showInActiveProblems)) return;
                    return (
                      <div className={`d-flex flex-column gap-1 ${["true", "True"].includes(item.MarkAsPrimary) && 'mark-as-primary-bg'}`}>
                        <div className="d-flex align-items-center gap-2">
                          <div className="d-flex align-items-center gap-1">
                            {["true", "True"].includes(item.MarkAsPrimary) &&
                              <div className="app_tooltip right">
                                <i className='icon-Star fs-11'></i>
                                <p class="tool_tip xsm_text text-light">Primary Problem</p>
                              </div>
                            }

                            <p className={`text validate-color cursor-pointer font-m ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddProblems(item.PatientProblemListID)}>{item.DiagnosisCode}</p>
                          </div>

                          {item.DiagnosisDescription && <p className='text validation_message text-nowrap' title={item.DiagnosisDescription}>- {item.DiagnosisDescription}</p>}
                        </div>

                        <div className="d-flex align-items-center justify-content-between">
                          {item.Acuity ?
                            <div className='d-flex align-items-center gap-1'>
                              <p className='text font-m'>Acuity:</p>
                              <p className='text'>{item.Acuity}</p>
                            </div>
                            : <></>}

                          {["false", "False"].includes(item.isActive) ?
                            <p className='text Partialdenied-clr fst-italic text-nowrap'>InActive</p>
                            :
                            <p className='text Paid-clr fst-italic text-nowrap'>Active</p>
                          }
                        </div>

                        {item.StartDate ?
                          <div className='d-flex align-items-center gap-1'>
                            <p className='text font-m'>Start Date:</p>
                            <p className='text'>{item.StartDate},</p>
                          </div>
                          : <></>}
                      </div>
                    )
                  })}
                </div>

                <ShowHideInActive />
              </> :
              <>
                {/* <div className="d-flex gap-6 align-items-center">
                  <div className="custom_check_box text-center d-flex">
                    <input
                      type="checkbox"
                      className="form-check-input mt-0"
                      name='IsAutoEligiblity'
                      id='IsAutoEligiblity'
                      checked={false}
                    />
                  </div>
                  <p className='text'>Patient has no active problems</p>
                </div> */}
              </>)}
        </div>
      </div>
    </>
  )
}

export default Problems